import {ReactNode} from "react";
import "./field-container.css";

interface FieldContainerProps {
    children: ReactNode | ReactNode[];
    title?: string;
    description?: string;
    className?: string;
}

const FieldContainer = ({ children, title, description, className }: FieldContainerProps) => {
    return (
        <div className={`field-container ${className}`}>
            {title ? <div className="title">{title}</div> : null}
            {children}
            {description ? <div className="description">{description}</div> : null}
        </div>
    )
}

export default FieldContainer;